import { ToastSkin as TOAST_SKIN } from 'wix-ui-tpa';
import { TFunction } from '@wix/yoshi-flow-editor';

import { Toast } from '../../../../../types';

export const getToastContent = (toast: Toast, t: TFunction) => {
  let toastSkin;
  let toastContent: string | null;

  switch (toast) {
    case Toast.AboutPublish:
      toastContent = t('about-page.success-message');
      toastSkin = TOAST_SKIN.success;
      break;
    case Toast.AboutPublishErrorTooManyLinks:
      toastContent = t('about-page.error-message.too-many-links');
      toastSkin = TOAST_SKIN.error;
      break;
    case Toast.AboutPublishErrorTextTooLong:
      toastContent = t('about-page.error-text-too-long');
      toastSkin = TOAST_SKIN.error;
      break;
    case Toast.AboutPublishErrorUnknown:
      toastContent = t('about-page.error-unknown');
      toastSkin = TOAST_SKIN.error;
      break;
    default:
      toastContent = null;
      toastSkin = TOAST_SKIN.success;
  }

  return {
    toastContent,
    toastSkin,
  };
};
